import React from "react"
import Layout from "./Layout"
function Protected() {
  return <Layout />
}

export default Protected
